const memberIdleSorter = (memberA, memberB) => {
	const protectionA = memberA.availabilityInfo?.isProtectionInDepartureLocation ?? false;
	const protectionB = memberB.availabilityInfo?.isProtectionInDepartureLocation ?? false;

	// First sort by protection status
	if (protectionA !== protectionB) {
		return protectionB - protectionA;
	}

	// Sort by descending idle time
	const idleA = memberA.availabilityInfo?.idleTimeMinutes ?? 0;
	const idleB = memberB.availabilityInfo?.idleTimeMinutes ?? 0;
	return idleB - idleA;
};

export const sortCrewMembersByIdleTime = (crewMembers) => {
	return [...crewMembers].sort(memberIdleSorter);
};
